/**
 * Champ de formulaire : label au-dessus, même style partout (clients, plus tard produits).
 */
import type { InputHTMLAttributes, ReactNode } from "react";
import "./copyButton.css";
import { MissTip } from "./MissTip";

type FieldProps = Omit<InputHTMLAttributes<HTMLInputElement>, "required"> & {
  label: string;
  hint?: ReactNode;
  suffix?: ReactNode;
  required?: boolean;
  showMiss?: boolean;
  missText?: string;
};

export function Field({
  label,
  hint,
  suffix,
  id,
  className = "",
  required,
  showMiss,
  missText,
  ...rest
}: FieldProps) {
  const inputId = id || rest.name;
  const off = rest.disabled ? " fx-field--off" : "";
  const miss = Boolean(showMiss) && !rest.disabled;
  return (
    <label className={`fx-field flex flex-col gap-1 text-xs${off}${miss ? " is-miss" : ""}`} htmlFor={inputId}>
      <span className="fx-field__lab">
        {label}
        {required ? <span className="fx-field__req" aria-hidden /> : null}
      </span>
      {suffix ? (
        <span className="fx-field__row">
          <input
            id={inputId}
            className={`rounded-md border px-2.5 py-2 text-sm ${className}`}
            aria-required={required || undefined}
            aria-invalid={miss || undefined}
            {...rest}
          />
          {suffix}
        </span>
      ) : (
        <input
          id={inputId}
          className={`rounded-md border px-2.5 py-2 text-sm ${className}`}
          aria-required={required || undefined}
          aria-invalid={miss || undefined}
          {...rest}
        />
      )}
      {miss ? <MissTip text={missText} /> : null}
      {hint ? <span className="text-slate-500">{hint}</span> : null}
    </label>
  );
}
